import { TAssetOperationTypeEnum } from '@/shared/hooks/use-assets-app-sync-events/use-assets-app-sync-events.types';
import { vaultsApi } from '@/shared/redux/api/assets/vaults/vaults-api';
import { useAppDispatch } from '@/shared/redux/hooks/hooks';

export const useInvalidateVaultTags = () => {
  const dispatch = useAppDispatch();

  const invalidateVaultTags = (
    vaultId: string,
    operationType: TAssetOperationTypeEnum,
  ) => {
    switch (operationType) {
      case TAssetOperationTypeEnum.AssetCreated:
      case TAssetOperationTypeEnum.AssetDeleted:
        dispatch(
          vaultsApi.util.invalidateTags([
            { type: 'Vault', id: 'LIST' },
            'Groups' as const,
          ]),
        );
        break;
      case TAssetOperationTypeEnum.AssetUpdated:
        dispatch(
          vaultsApi.util.invalidateTags([
            { type: 'Vault', id: vaultId },
            { type: 'Vault', id: 'LIST' },
            'Groups' as const,
          ]),
        );
        break;
    }
  };

  const invalidateSecretTags = (
    secretId: string,
    operationType: TAssetOperationTypeEnum,
    vaultId?: string,
  ) => {
    switch (operationType) {
      case TAssetOperationTypeEnum.AssetCreated:
      case TAssetOperationTypeEnum.AssetDeleted:
        dispatch(
          vaultsApi.util.invalidateTags([
            { type: 'Vault', id: vaultId },
            { type: 'Vault', id: 'LIST' },
            'Groups' as const,
          ]),
        );
        break;
      case TAssetOperationTypeEnum.AssetUpdated:
        dispatch(
          vaultsApi.util.invalidateTags([
            { type: 'Vault', id: vaultId },
            { type: 'Vault', id: 'LIST' },
            { type: 'SecretUnceiled', id: secretId },
          ]),
        );
        break;
    }
  };

  return {
    invalidateVaultTags,
    invalidateSecretTags,
  };
};
